import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import store from "../store/index.js"

const CANONICAL_ORIGIN = "https://tandzorggestel.nl";


const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "Tandarts Sint-Michielsgestel | Tandzorg Gestel | Nieuwe Patiënten Welkom",
      description: "Tandarts Sint-Michielsgestel ✓ Tandzorg Gestel ✓ Ervaren tandartspraktijk in Gestel met persoonlijke aandacht en moderne technieken. Nieuwe patiënten welkom! Bel 073-5515644.",
      keywords: "tandarts sint michielsgestel, tandarts gestel, tandzorg gestel, tandheelkunde sint-michielsgestel, nieuwe patiënten, afspraak maken"
    }
  },
  {
    path: "/over-ons",
    name: "AboutUs",
    component: () =>
      import("../views/AboutUs.vue"),
    meta: {
      title: "Over Ons | Tandzorg Gestel | Ervaren Tandartsen Sint-Michielsgestel",
      description: "Leer ons team kennen bij Tandzorg Gestel. Ervaren tandartsen en mondhygiënisten die zorgen voor uw mondgezondheid in Sint-Michielsgestel.",
      keywords: "tandarts team, over ons, ervaren tandartsen, Sint-Michielsgestel, tandzorg gestel"
    }
  },
  {
    path: "/diensten",
    name: "Services",
    component: () =>
      import("../views/Services.vue"),
    meta: {
      title: "Tandheelkundige Diensten | Tandzorg Gestel | Behandelingen Sint-Michielsgestel",
      description: "Complete tandheelkundige zorg: controles, vullingen, wortelkanaalbehandelingen, cosmetische tandheelkunde en meer bij Tandzorg Gestel.",
      keywords: "tandheelkundige diensten, wortelkanaal, cosmetische tandheelkunde, vullingen, controles, behandelingen"
    }
  },
  {
    path: "/het-team",
    name: "TheTeam",
    component: () =>
      import("../views/TheTeam.vue"),
    meta: {
      title: "Ons Team | Tandzorg Gestel | Tandartsen en Mondhygiënisten",
      description: "Maak kennis met ons professionele team van tandartsen, mondhygiënisten en assistentes bij Tandzorg Gestel in Sint-Michielsgestel.",
      keywords: "tandarts team, mondhygiënist, tandzorg medewerkers, professioneel team, Sint-Michielsgestel"
    }
  },
  {
    path: "/de-lieve-tandarts",
    name: "LieveTandarts",
    component: () =>
      import("../views/LieveTandarts.vue"),
    meta: {
      title: "De Lieve Tandarts | Tandzorg Gestel | Kwaliteit & Zorg",
      description: "Tandzorg Gestel is aangesloten bij De Lieve Tandarts. Ontdek wat dit keurmerk betekent voor uw tandheelkundige zorg en service.",
      keywords: "lieve tandarts, keurmerk, kwaliteit tandheelkunde, extra aandacht, goede zorg"
    }
  },
  {
    path: "/team-lid/:memberid",
    name: "TeamMember",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/TeamMember.vue"),
      beforeEnter(to) {
        const id = to.params.memberid;
        const localMembers = store.state.members;
        const exists = localMembers.some((member) => member.id === id);

        if(!exists) return {
          name: "NotFound",
          params: {pathMatch: to.path.substring(1).split("/")},
          query: to.query,
          hash: to.hash
        };

      },
    meta: {
      title: "Team Lid | Tandzorg Gestel",
      description: "Informatie over onze tandarts of mondhygiënist bij Tandzorg Gestel in Sint-Michielsgestel.",
      keywords: "tandarts, mondhygiënist, team lid, tandzorg gestel"
    }
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/NotFound.vue"),
    meta: {
      title: "Pagina Niet Gevonden | Tandzorg Gestel",
      description: "De pagina die u zoekt bestaat niet. Ga terug naar de homepage van Tandzorg Gestel.",
      keywords: "404, pagina niet gevonden, tandzorg gestel"
    }
  },
  {
    path: "/contact",
    name: "Contact",
    component: () =>
      import("../views/Contact.vue"),
    meta: {
      title: "Contact | Tandzorg Gestel | Afspraak Maken Sint-Michielsgestel",
      description: "Neem contact op met Tandzorg Gestel voor afspraken, vragen of spoedgevallen. Bereikbaar in Sint-Michielsgestel. Nieuwe patiënten welkom!",
      keywords: "contact, afspraak maken, tandarts contact, Sint-Michielsgestel, spoed tandarts"
    }
  },
  {
    path: "/info",
    name: "Info",
    component: () =>
      import("../views/Info.vue"),
    meta: {
      title: "Praktijk Informatie | Tandzorg Gestel | Openingstijden & Tarieven",
      description: "Praktische informatie over Tandzorg Gestel: openingstijden, tarieven, verzekeringen, locatie en wat u kunt verwachten bij uw bezoek.",
      keywords: "praktijk info, openingstijden, tarieven, verzekeringen, locatie, tandarts informatie"
    }
  },
  {
    path: "/spoed",
    name: "Spoed",
    component: () =>
      import("../views/Spoed2.vue"),
    meta: {
      title: "Spoedgevallen | Tandzorg Gestel | 24/7 Spoed Tandarts Sint-Michielsgestel",
      description: "Spoedgevallen bij Tandzorg Gestel. Contact informatie voor spoedeisende tandheelkundige hulp in Sint-Michielsgestel en omgeving.",
      keywords: "spoed tandarts, spoedgevallen, 24/7 tandarts, nood tandarts, pijn, Sint-Michielsgestel"
    }
  },
  {
    path: "/afspraak-maken",
    name: "AfspraakMaken",
    component: () =>
      import("../views/AfspraakMaken.vue"),
    meta: {
      title: "Afspraak maken | Tandzorg Gestel | Online Afspraak Inplannen",
      description: "Maak eenvoudig online een afspraak bij Tandzorg Gestel. Snel en gemakkelijk inplannen voor tandheelkundige zorg.",
      keywords: "afspraak maken, online afspraak, tandarts afspraak, Sint-Michielsgestel"
    }
  },
  {
    path: "/inschrijven",
    name: "Inschrijven",
    component: () =>
      import("../views/Inschrijven.vue"),
    meta: {
      title: "Inschrijven | Tandzorg Gestel | Nieuwe Patiënt Worden",
      description: "Schrijf u in als nieuwe patiënt bij Tandzorg Gestel in Sint-Michielsgestel. Gemakkelijk online inschrijven voor kwaliteitsvolle tandheelkundige zorg.",
      keywords: "inschrijven, nieuwe patiënt, tandarts inschrijving, Sint-Michielsgestel, registreren"
    }
  },
  {
    path: "/bedankt",
    name: "Bedankt",
    component: () =>
      import("../views/Bedankt.vue"),
    meta: {
      title: "Bedankt voor uw inschrijving | Tandzorg Gestel",
      description: "Bedankt voor uw inschrijving bij Tandzorg Gestel. Wij nemen spoedig contact met u op voor uw eerste afspraak.",
      keywords: "bedankt, inschrijving voltooid, nieuwe patiënt bevestiging"
    }
  },
  {
    path: "/wortelkanaalbehandeling",
    name: "Wortelkanaalbehandeling",
    beforeEnter() {
      store.commit('updateScrollToServices', 'cavity-inspection')
      return { path: '/diensten' }
    },
    meta: {
      title: "Wortelkanaalbehandeling Sint-Michielsgestel | Tandzorg Gestel | Pijnloze Behandeling",
      description: "Professionele wortelkanaalbehandeling bij Tandzorg Gestel in Sint-Michielsgestel. Pijnloze behandeling met moderne technieken. Spoed mogelijk.",
      keywords: "wortelkanaalbehandeling, endodontie, tandpijn, tandarts Sint-Michielsgestel, Tandzorg Gestel, wortelkanaal, kiespijn"
    }
  },
  {
    path: "/cosmetische-tandheelkunde",
    name: "CosmetischeTandheelkunde", 
    beforeEnter() {
      store.commit('updateScrollToServices', 'oral-hygiene-experts')
      return { path: '/diensten' }
    },
    meta: {
      title: "Cosmetische Tandheelkunde Sint-Michielsgestel | Tandzorg Gestel | Veneers & Bleaching",
      description: "Cosmetische tandheelkunde bij Tandzorg Gestel: veneers, tandenbleken, bonding en meer. Transform uw glimlach in Sint-Michielsgestel.",
      keywords: "cosmetische tandheelkunde, veneers, tandenbleken, teeth whitening, facings, bonding, glimlach verbeteren, tandarts Sint-Michielsgestel"
    }
  },
  {
    path: "/mondhygiene", 
    name: "Mondhygiene",
    beforeEnter() {
      store.commit('updateScrollToServices', 'live-dental-advisory')
      return { path: '/diensten' }
    },
    meta: {
      title: "Mondhygiëne Sint-Michielsgestel | Tandzorg Gestel | Professionele Tandreinigingen",
      description: "Professionele mondhygiëne en tandreinigingen bij Tandzorg Gestel in Sint-Michielsgestel. Ervaren mondhygiënisten, preventieve zorg.",
      keywords: "mondhygiëne, mondhygiënist, tandreinigingen, tandvlees, periodontologie, plaque, tandsteen, Sint-Michielsgestel"
    }
  },
  {
    path: "/tandarts-den-bosch",
    name: "TandartsDenBosch",
    component: () =>
      import("../views/TandartsDenBosch.vue"),
    meta: {
      title: "Tandarts Den Bosch omgeving | Tandzorg Gestel Sint-Michielsgestel | Dichtbij 's-Hertogenbosch",
      description: "Tandarts gezocht in Den Bosch omgeving? Tandzorg Gestel in Sint-Michielsgestel ligt op 10 min van Den Bosch. Gratis parkeren, persoonlijke zorg.",
      keywords: "tandarts Den Bosch, tandarts s-hertogenbosch, tandarts bij Den Bosch, Sint-Michielsgestel tandarts, Tandzorg Gestel"
    }
  },
  {
    path: "/tandarts-vught",
    name: "TandartsVught",
    component: () =>
      import("../views/TandartsVught.vue"),
    meta: {
      title: "Tandarts Vught | Tandzorg Gestel Sint-Michielsgestel | 8 Min Rijden",
      description: "Tandarts Vught gezocht? Tandzorg Gestel in Sint-Michielsgestel ligt op 8 minuten van Vught. Persoonlijke zorg, gratis parkeren, moderne technieken.",
      keywords: "tandarts Vught, tandarts 5261, tandarts Cromvoirt, tandarts Helvoirt, tandheelkunde Vught, Sint-Michielsgestel"
    }
  },
  {
    path: "/tandarts-boxtel",
    name: "TandartsBoxtel",
    component: () =>
      import("../views/TandartsBoxtel.vue"),
    meta: {
      title: "Tandarts Boxtel | Tandzorg Gestel Sint-Michielsgestel | 12 Min Rijden",
      description: "Tandarts Boxtel? Tandzorg Gestel in Sint-Michielsgestel ligt op 12 minuten van Boxtel. Persoonlijke zorg, moderne technieken, ook Liempde en Best.",
      keywords: "tandarts Boxtel, tandarts 5281, tandarts Liempde, tandarts Best, tandheelkunde Boxtel, Sint-Michielsgestel"
    }
  },
  {
    path: "/tandarts-haaren",
    name: "TandartsHaaren",
    component: () =>
      import("../views/TandartsHaaren.vue"),
    meta: {
      title: "Tandarts Haaren | Tandzorg Gestel Sint-Michielsgestel | 8 Min Rijden",
      description: "Tandarts Haaren? Tandzorg Gestel in Sint-Michielsgestel ligt op 8 minuten van Haaren. Persoonlijke zorg, moderne technieken, ook Esch en Helvoirt.",
      keywords: "tandarts Haaren, tandarts 5076, tandarts Esch, tandarts Helvoirt, tandheelkunde Haaren, Sint-Michielsgestel"
    }
  },
  {
    path: "/tandarts-berlicum",
    name: "TandartsBerlicum",
    component: () =>
      import("../views/TandartsBerlicum.vue"),
    meta: {
      title: "Tandarts Berlicum | Tandzorg Gestel Sint-Michielsgestel | Dichtbij en persoonlijk",
      description: "Tandarts Berlicum gezocht? Tandzorg Gestel in Sint-Michielsgestel ligt dichtbij Berlicum. Persoonlijke zorg, moderne technieken en gratis parkeren.",
      keywords: "tandarts Berlicum, tandarts Middelrode, tandarts omgeving Berlicum, tandarts Sint-Michielsgestel, tandheelkunde Berlicum, Tandzorg Gestel"
    }
  },
  {
    path: "/tandarts-schijndel",
    name: "TandartsSchijndel",
    component: () =>
      import("../views/TandartsSchijndel.vue"),
    meta: {
      title: "Tandarts Schijndel | Tandzorg Gestel Sint-Michielsgestel | Dichtbij en vertrouwd",
      description: "Tandarts Schijndel gezocht? Tandzorg Gestel in Sint-Michielsgestel is goed bereikbaar vanuit Schijndel. Persoonlijke zorg, moderne technieken en gratis parkeren.",
      keywords: "tandarts Schijndel, tandarts Wijbosch, tandarts Eerde, tandarts omgeving Schijndel, tandarts Sint-Michielsgestel, Tandzorg Gestel"
    }
  },
  {
    path: "/tandarts-liempde",
    name: "TandartsLiempde",
    component: () =>
      import("../views/TandartsLiempde.vue"),
    meta: {
      title: "Tandarts Liempde | Tandzorg Gestel Sint-Michielsgestel | Korte reistijd",
      description: "Tandarts Liempde gezocht? Tandzorg Gestel in Sint-Michielsgestel is goed bereikbaar vanuit Liempde. Persoonlijke zorg, moderne tandheelkunde en gratis parkeren.",
      keywords: "tandarts Liempde, tandarts omgeving Liempde, tandarts Boxtel, tandarts Sint-Michielsgestel, tandheelkunde Liempde, Tandzorg Gestel"
    }
  },
  {
    path: "/privacy-policy",
    name: "Privacy",
    component: () =>
      import("../views/Privacy.vue"),
    meta: {
      title: "Privacy Beleid | Tandzorg Gestel",
      description: "Privacy beleid van Tandzorg Gestel. Hoe wij omgaan met uw persoonlijke gegevens en medische informatie.",
      keywords: "privacy beleid, gegevensbescherming, AVG, privacyverklaring"
    }
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    if (to.hash) {
      return new Promise((resolve) => {
        const tryScroll = () => {
          const element = document.querySelector(to.hash)
          if (element) {
            resolve({ el: to.hash, top: 110, behavior: 'smooth' })
            return true
          }
          return false
        }

        if (tryScroll()) {
          return
        }

        setTimeout(() => {
          if (!tryScroll()) {
            resolve({ top: 0 })
          }
        }, 50)
      })
    }

    return { top: 0 }
  }
});

// Update meta tags on route change
router.beforeEach((to) => {
  const canonicalPath = to.path === "/" ? "/" : to.path.replace(/\/+$/, "");
  const canonicalUrl = `${CANONICAL_ORIGIN}${canonicalPath}`;

  // Update document title
  if (to.meta?.title) {
    document.title = to.meta.title;
  }
  
  // Update meta description
  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription && to.meta?.description) {
    metaDescription.setAttribute('content', to.meta.description);
  }
  
  // Update meta keywords
  const metaKeywords = document.querySelector('meta[name="keywords"]');
  if (metaKeywords && to.meta?.keywords) {
    metaKeywords.setAttribute('content', to.meta.keywords);
  }
  
  // Update Open Graph title
  const ogTitle = document.querySelector('meta[property="og:title"]');
  if (ogTitle && to.meta?.title) {
    ogTitle.setAttribute('content', to.meta.title);
  }
  
  // Update Open Graph description
  const ogDescription = document.querySelector('meta[property="og:description"]');
  if (ogDescription && to.meta?.description) {
    ogDescription.setAttribute('content', to.meta.description);
  }
  
  // Update Twitter title
  const twitterTitle = document.querySelector('meta[property="twitter:title"]');
  if (twitterTitle && to.meta?.title) {
    twitterTitle.setAttribute('content', to.meta.title);
  }
  
  // Update Twitter description
  const twitterDescription = document.querySelector('meta[property="twitter:description"]');
  if (twitterDescription && to.meta?.description) {
    twitterDescription.setAttribute('content', to.meta.description);
  }

  // Keep canonical and social URLs aligned with the current route
  const canonicalLink = document.querySelector('link[rel="canonical"]');
  if (canonicalLink) {
    canonicalLink.setAttribute('href', canonicalUrl);
  }

  const ogUrl = document.querySelector('meta[property="og:url"]');
  if (ogUrl) {
    ogUrl.setAttribute('content', canonicalUrl);
  }

  const twitterUrl = document.querySelector('meta[property="twitter:url"]');
  if (twitterUrl) {
    twitterUrl.setAttribute('content', canonicalUrl);
  }

  const robots = document.querySelector('meta[name="robots"]');
  if (robots) {
    const noIndexRoutes = ['NotFound', 'Bedankt'];
    robots.setAttribute('content', noIndexRoutes.includes(to.name) ? 'noindex, nofollow' : 'index, follow');
  }
});

export default router;
